import React, { useState, useCallback, useEffect, createContext } from 'react'
import { useDispatch } from 'react-redux'

import NoSearchResult from 'components/NoSearchResult/NoSearchResult'
import PageHeader from './compoments/PageHeader'
import PageBody from './compoments/PageBody'
import PanelEditModal from './compoments/PanelEditModal'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import {
  loadingPanel,
  getPanelListSelector,
  getIsfetchingDevicesSelector,
} from 'redux/reducers/devices'
import { useShallowEqualSelector } from 'custom-hooks'

export const PanelContext = createContext()

export const defaultFilterValue = {
  id: 'default_panel_status',
  label: 'All panel status',
}

const PanelsManagement = () => {
  const dispatch = useDispatch()

  const panelsList = useShallowEqualSelector(getPanelListSelector)
  const isFetchingLoadPanel = useShallowEqualSelector(
    getIsfetchingDevicesSelector
  )

  const [selectPanelId, setSelectedPanelId] = useState(null)
  const [search, setSearch] = useState('')
  const [filterValue, setFilterValue] = useState(defaultFilterValue)

  const handleEditPanel = useCallback(
    (panelId) => () => {
      setSelectedPanelId(panelId)
    },
    []
  )

  const handleCloseModal = useCallback(() => {
    setSelectedPanelId(null)
  }, [])

  useEffect(() => {
    dispatch(loadingPanel())
  }, [dispatch])

  const _filterData = panelsList?.filter((panel) => {
    if (filterValue.value === 1) return panel.location_id
    if (filterValue.value === 0) return !panel.location_id
    return panel
  })

  const _searchFilterData = _filterData?.filter((p) =>
    String(p.name).toLowerCase().includes(String(search).toLowerCase())
  )

  return (
    <PanelContext.Provider
      value={{
        search: {
          value: search,
          onChange: setSearch,
        },
        filter: {
          value: filterValue,
          onChange: setFilterValue,
        },
      }}
    >
      <div className="page_container panel_management_page_container">
        {isFetchingLoadPanel && <Spinner />}
        <PageHeader />
        {_searchFilterData?.length ? (
          <PageBody
            handleEditPanel={handleEditPanel}
            data={_searchFilterData}
          />
        ) : (
          <NoSearchResult
            title={isFetchingLoadPanel ? 'Loading...' : 'No result'}
          />
        )}
        {!!selectPanelId && (
          <PanelEditModal
            selectPanelId={selectPanelId}
            handleClose={handleCloseModal}
          />
        )}
      </div>
    </PanelContext.Provider>
  )
}

export default PanelsManagement
